/* global jQuery espn */
import React, { Component } from 'react'
import selectn from 'selectn'

class Article extends Component {
  constructor() {
    super()
  }

  shouldComponentUpdate(/*nextProps*/) {
    /*
     * Alternate solution to hinder articale update id the same article is getting updated
     *
    const articleId = selectn('article.id', this.props)
    const articleIdNext = selectn('article.id', nextProps)
    const html = selectn('article.html', this.props) || ''
    const htmlNext = selectn('article.html', nextProps) || ''

    return articleId !== articleIdNext ? true : html.length !== htmlNext.length
    */
    try {
      const embeddedPlayerId = selectn('video.player.embeddedPlayerId', espn) || ''
      // prevent the article update if the video element is present in the DOM
      if(embeddedPlayerId !== '') {
        return jQuery('#article-feed ' + '#' + embeddedPlayerId).size() > 0 ? false : true
      } else {
        return true
      }
    } catch (err) {
      console.error(err)
      // in case of any error component should get updated
      return true
    }
  }

  render() {
    const { article = {} } = this.props
    let articleMarkup = article.html || ''
    articleMarkup = articleMarkup.replace('<\\/script>','<\/script>')
    return (
      <section id="article-feed"
        className="col-b"
        data-behavior="author_overlay article_header_news_feed_item_meta social_tools comment"
        dangerouslySetInnerHTML={{ __html: articleMarkup }}>
      </section>
    )
  }
}

export default Article



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/Article.jsx
 **/